module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error"
  }, [_c('a-layout', {
    staticStyle: {
      "min-height": "100vh"
    },
    attrs: {
      "id": "components-layout-demo-side"
    }
  }, [_c('menuBar', {
    attrs: {
      "current": _vm.current,
      "openKeys": _vm.openKeys
    }
  }), _vm._v(" "), _c('a-layout', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('topBar'), _vm._v(" "), _c('a-layout-content', {
    staticStyle: {
      "margin": "16px",
      "min-width": "1192px"
    }
  }, [_c('div', {
    staticClass: "contentcard"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "top": "20%",
      "position": "relative"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "100px",
      "color": "#4b505d",
      "margin": "0"
    }
  }, [_vm._v("500")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "20px",
      "color": "rgba(0,0,0,.45)"
    }
  }, [_vm._v("抱歉，服务器出错了")]), _vm._v(" "), _c('a-button', {
    staticStyle: {
      "width": "96px",
      "font-size": "12px"
    },
    attrs: {
      "ghost": "",
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function () {
        this$1.$router.push('mainpage')
      }
    }
  }, [_vm._v("返回首页")])], 1)])]), _vm._v(" "), _c('bottomBar')], 1)], 1), _vm._v(" "), _c('div', [_c('a-back-top')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08d03bc7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/components/view/500/index.vue
// module id = 2362
// module chunks = 1